export default __webpack_public_path__ + "static/media/change-plan-modal.74117f5a.svg";